import type React from "react"
import { AdminSidebar } from "./AdminSidebar"

interface AdminDashboardLayoutProps {
  children: React.ReactNode
}

export function AdminDashboardLayout({ children }: AdminDashboardLayoutProps) {
  return (
    <div className="min-h-screen" style={{ background: "linear-gradient(180deg, #E4F3FF 35.1%, #F4F9FF 100%)" }}>
      <AdminSidebar />
      <div className="lg:pl-64">
        <main className="py-6 px-4 lg:px-8">{children}</main>
      </div>
    </div>
  )
}